
import Vue from 'vue'
import { QInput, QSelect } from 'quasar'
import { plzOptions } from '../helpers/plz'
import states from '../helpers/states'

export default Vue.extend({
    components: { QInput, QSelect },
    props: {
        filter: {
            type: Object as any,
            default: () => ({}) as any
        },
        users: {
          type: Array,
          default: () => []
        }
    },
    data() {
      return {
        plzOptions: []
      }
    },
    computed: {
        distanceOptions() {
          return [
            0,
            20,
            50,
            100,
            150,
            200,
            250,
            300,
            400,
            500,
            700,
            1000
          ].map(d => ({
            label: `${d} km`,
            value: d
          }))
        },
        label() {
            let filter: string[] = []
            if(this.filter.isResponsibleActive && this.filter.responsible) {
              filter.push(this.filter.responsible)
            }
            if(this.filter.onlyActive) {
              filter.push('nur aktive')
            }
            if(this.filter.isStateActive && (this as any).selectedState) {
              filter.push((this as any).selectedState.label)
            }
            if(this.filter.isDistanceActive && this.filter.postcode && this.filter.distance !== null) {
              filter.push(`max ${this.filter.distance}km von ${this.filter.postcode}`)
            }
            return filter.join(', ')
        },
        stateOptions() {
          let res: any[] = []
          for(let key in states) {
            res.push({
              value: key,
              label: states[key].label,
              icon: states[key].icon,
              color: states[key].color
            })
          }
          return res
        },
        selectedState() {
          const state = states[this.filter.state];
          if(!state) return null
          return {
              value: this.filter.state,
              label: state.label,
              icon: state.icon,
              color: state.color
          }
        }
    },
    methods: {
      plzFilterFn (val, update) {
        if (val === '') {
          update(() => {
            (this as any).plzOptions = []
          })
          return
        }

        update(() => {
          const needle = val.toLowerCase()

          (this as any).plzOptions = plzOptions.filter(({label}) => label.toLowerCase().indexOf(needle) > -1)
        })
      }
    }
})
